import React from 'react';
import style from './help-fallback.component.module.less';
import classNames from 'classnames';
import { SkeletonLoaderComponent } from '@vaad1st/component.atom.skeleton-loader';

const HelpFallback = () => {
  const unit = 'px';
  const height = '80';
  const loading = true;

  return (
    <div className={classNames(style.helpFallback)}>
      <div>
        <SkeletonLoaderComponent unit={unit} height="226" loading={loading} />
      </div>
      <div className={classNames(style.grid)}>
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
        <SkeletonLoaderComponent
          unit={unit}
          height={height}
          loading={loading}
        />
      </div>
      <div>
        <SkeletonLoaderComponent unit={unit} height="226" loading={loading} />
      </div>
    </div>
  );
};

export default HelpFallback;
